import { getLanguage } from "./get-language.js";
const getSearchLocalizedValue = (attributes, attribute, locale) => {
  const localizedValue = attributes[`${attribute}_${locale}`];
  if (localizedValue) return localizedValue;
  const languageCode = getLanguage(locale);
  return attributes[`${attribute}_${languageCode}`];
};
const getSearchJoinedLocalizedValues = (attributes, attribute, locale, separator = ", ") => {
  const localizedValue = attributes[`${attribute}_${locale}`];
  if (localizedValue && Array.isArray(localizedValue)) return localizedValue.join(separator);
  const languageCode = getLanguage(locale);
  const languageValue = attributes[`${attribute}_${languageCode}`];
  if (languageValue && Array.isArray(languageValue)) return languageValue.join(separator);
  return "";
};
export {
  getSearchJoinedLocalizedValues,
  getSearchLocalizedValue
};
//# sourceMappingURL=get-search-localized-value.js.map
